import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const auditLogsAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.AuditLogs],
  featureToggles: FeatureToggle.auditLogs,
  restrictedBannersAllowed: true,
}
